import sprintf from 'sprintf';
import Cookies from 'js.cookie';

class SMRestClient {
  getDefaultParams(){
    return {
      //timeout: 10000,
      dataType: "json",
      accepts: {json: "application/json"},
      cache: false,
      headers: {
        Authorization: sprintf("Bearer %s", SpaceMarket.Session.AccessToken),
        'x-api-key': SpaceMarket.Config.APIKey,
        'Spacemarket-Version': SpaceMarket.Config.APIVersion,
        'Spacemarket-Forwarded-History-Id': Cookies.get('history_id')
      },
      context: document.body,
    };
  }
  
  static getLinks(xhr){
    return this.parseLinkString(xhr.getResponseHeader("Link"));
  }
  
  static parseLinkString(linkString){
    let links = {};
    if (!linkString) return links;
    const linkHeader = linkString.replace(/\s+/g, "");
    const linkData = linkHeader.split(",");
    for (var i = 0; i < linkData.length; i++) {
      var elements = linkData[i].split(";"),
          url = elements[0].replace(/(<|>)/g,""),
          rels = elements[1].split("=");
      links[rels[1].replace(/"/g, "")] = url;
    }
    return links;
  }
  
  static isTokenExpired(){
    return (new Date() / 1000 > SpaceMarket.Session.AccessTokenExpiresAt);
  }
  
  refreshToken(callback){
    $.ajax({
      type: 'POST',
      url: "/oauth/token",
      // headers: {
      //   "X-CSRF-Token" : $('meta[name=csrf-token]').attr('content')
      // },
      data: {refresh_token: SpaceMarket.Session.RefreshToken},
    }).
    done(function(data, textStatus, xhr) {
      SpaceMarket.Session.AccessToken = data.access_token;
      SpaceMarket.Session.RefreshToken = data.refresh_token;
      SpaceMarket.Session.AccessTokenExpiresAt = data.access_token_expires_at;
      if (typeof callback === 'function') {
        callback();
      }
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
    });
  }
  
  get(url){
    let parameters = this.getDefaultParams();
    parameters = Object.assign(parameters, {
      url: SpaceMarket.Config.APIHost + url,
      type: "GET",
    });
    return $.ajax(parameters);
  }

  post(url, data){
    let parameters = this.getDefaultParams();
    parameters = Object.assign(parameters, {
      url: SpaceMarket.Config.APIHost + url,
      type: "POST",
    });
    if (data && data instanceof FormData) {
      parameters = Object.assign(parameters, {
        data: data,
        processData: false,
        contentType: false
      });
    } else {
      parameters = Object.assign(parameters, {
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data),
      });
    }
    return $.ajax(parameters);
  }

  patch(url, data){
    let parameters = this.getDefaultParams();
    parameters = Object.assign(parameters, {
      url: SpaceMarket.Config.APIHost + url,
      type: "PATCH",
    });
    if (data) {
      if (data instanceof FormData) {
        parameters = Object.assign(parameters, {
          data: data,
          processData: false,
          contentType: false
        });
      } else {
        parameters = Object.assign(parameters, {
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(data),
        });
      }
    }
    return $.ajax(parameters);
  }

  patchWithJson(url, payload) {
    let parameters = this.getDefaultParams();
    parameters = Object.assign(parameters, {
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify(payload),
      url: SpaceMarket.Config.APIHost + url,
      type: "PATCH",
    });
    return $.ajax(parameters);
  }

  destroy(url, formData){
    let parameters = this.getDefaultParams();
    parameters = Object.assign(parameters, {
      url: SpaceMarket.Config.APIHost + url,
      type: "DELETE",
    });
    if (formData) {
      parameters = Object.assign(parameters, {
        data: formData,
        processData: false,
        contentType: false
      });
    }
    return $.ajax(parameters);
  }

}
export default SMRestClient;



// WEBPACK FOOTER //
// ./app/javascript/lib/SMRestClient.js